// extracted by mini-css-extract-plugin
module.exports = {"background":"auth_background__1qY88","logo":"auth_logo__10wXd"};